<template>
  <div>
    <input class="d-none" data-target="#BoxViewScoresModal" data-toggle="modal" ref="openBoxViewScoresModal" />
    <div class="modal fade" id="BoxViewScoresModal" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Boxscores Details</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeKeepScoresModal">
              <img src="../../assets/Svg/close.svg" alt="close" />
            </button>
          </div>
          <div class="modal-body pb-0">
            <!-- Start -->
            <div>
              <div class="container-fluid no-pdd">
                <div class="row no-gutters">
                  <div class="game-content">
                    <div class="d-flex align-items-center flex-wrap flex-lg-nowrap" style="gap: 5px">
                      <div class="live-tag" v-if="gameScore.game_live == 1 && gameScore.game_delayed == 0">
                        <p>Live</p>
                      </div>
                      <div class="delayed-tag pl-0" v-if="gameScore.game_live == 1 && gameScore.game_delayed == 1">
                        <img src="../../assets/Svg/delayed.svg" alt="delayed" />
                      </div>
                      <div class="final-count" v-if="gameScore.status == 2">
                      <span>F</span>
                    </div>
                      <span class="game-name">{{ gameScore.game_name }}</span>
                    </div>

                    <div class="d-flex align-items-center flex-wrap justify-content-between w-100" style="gap: 5px">
                      <div class="game-info-section">
                        <div class="field-data">
                          <img src="../../assets/Svg/calendar.svg" />
                          <p>
                            <span>Scheduled:</span>
                            <span>{{ gameScore?.start_date | formatDateOfBirth }}
                              {{ gameScore?.start_time }}
                            </span>
                          </p>
                        </div>
                        <div class="field-data" v-if="gameScore.game_scores?.length != 0">
                          <img src="../../assets/Svg/clock.svg" />
                          <p>
                            <span>Actual Start:</span>
                            <span v-if="gameScore.actual_start_time">{{ gameScore.actual_start_time | formatTimeToAM
                            }}
                            </span>
                            <span v-else>-</span>
                          </p>
                        </div>
                        <div class="field-data" v-if="gameScore.game_scores?.length != 0">
                          <img src="../../assets/Svg/timer-start-outline.svg" />
                          <p>
                            <span>Time Limit:</span>
                            <span v-if="gameScore.time_limit">{{ gameScore.time_limit }} minutes
                            </span>
                            <span v-else>-</span>
                          </p>
                        </div>

                        <div class="field-data" v-if="gameScore.field || gameScore.park">
                          <img src="../../assets/Svg/maximize.svg" />
                          <div>
                            <p>
                              <span v-if="gameScore.park">
                                {{ gameScore.park.park_name }}
                              </span>

                              <span v-if="gameScore.field">
                                - {{ gameScore.field.field_name }}
                              </span>
                            </p>

                            <p v-if="gameScore.park" @click="openGoogleMapforGamePark(gameScore.park)"
                              class="game-bottom-location">
                              <span v-if="
                                gameScore.park.address != '' &&
                                gameScore.park.address != 'null' &&
                                gameScore.park.address != null
                              ">
                                {{ gameScore.park.address }}
                              </span>
                              <span v-else>
                                {{ gameScore.park.park_name }}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          {{ gameScore?.tournament?.event?.eventName }}
                        </div>
                        <div>
                          {{ gameScore?.tournament?.tournamentName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-tables d-flex align-items-centered p-2" v-if="gameScore != []">
              <table class="table table-teams mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <!-- <th>Inning</th> -->
                  </tr>
                </thead>
                <tbody v-for="score in gameScore.game_scores" :key="score.id + 1000">
                  <tr v-if="score.team_type == 1">
                    <th scope="row" class="py-0">
                      <div class="team-name d-flex align-items-center">
                        <div class="user-img mr-2">
                          <div class="users-notification" v-if="imgLoader == 1">
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img @load="onImageLoad" v-if="score.team.team_avatar" :src="url + score.team.team_avatar"
                            alt="" style="border: 2px solid white;" />
                          <img @load="onImageLoad" v-else alt="" src="../../assets/Svg/people.svg" />
                        </div>
                        <span>#{{ score.teams.team_sr_no }} {{ score.team.team_name }}</span>
                      </div>

                      <!-- <div class="team-type">Visiting Team</div> -->
                    </th>
                    <th class="pb-0">Runs</th>
                  </tr>
                  <tr v-if="score.team_type == 1">
                    <th scope="row"></th>
                    <th class="pt-0">HR</th>
                  </tr>
                </tbody>
                <tbody v-for="score in gameScore.game_scores" :key="score.id + 2000">
                  <tr v-if="score.team_type == 2">
                    <th scope="row" class="py-0">
                      <div class="team-name d-flex align-items-center">
                        <div class="user-img mr-2">
                          <div class="users-notification" v-if="imgLoader == 1">
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img @load="onImageLoad" v-if="score.team.team_avatar" :src="url + score.team.team_avatar"
                            alt="" style="border: 2px solid white;" />
                          <img @load="onImageLoad" v-else alt="" src="../../assets/Svg/people.svg" />
                        </div>
                        <span>#{{ score.teams.team_sr_no }} {{ score.team.team_name }}</span>
                      </div>
                      <!-- <div class="team-type">Home Team</div> -->
                    </th>
                    <th class="pb-0">Runs</th>
                  </tr>
                  <tr v-if="score.team_type == 2">
                    <th scope="row"></th>
                    <th class="pt-0">HR</th>
                  </tr>
                </tbody>
              </table>
              <InningTournament />
            </div>
            <!-- End -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InningTournament from "./InningTournament.vue";
export default {
  name: "InningTournamentModal",
  components: {
    InningTournament,
  },
  data: function () {
    return {
      url: this.$groupAvatarStorageURL,
      imgLoader: 1,
      gameScore: [],
    };
  },
  methods: {
    onImageLoad() {
      this.imgLoader = 0;
    },

    closeModal() {
      var elem = this.$refs.closeKeepScoresModal;
      if (elem) {
        elem.click();
      }
    },
    openGoogleMapforGamePark(item) {
      const strlatLng = item["lat"] + "," + item["lng"];
      const urlSuffix = strlatLng ? strlatLng : item["address"];

      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },
  },
  mounted() {
    this.$root.$on("openBoxViewScoresModal", (score) => {
      this.gameScore = [];
      this.gameScore = score;
      var elem = this.$refs.openBoxViewScoresModal;
      if (elem) {
        elem.click();
      }
    });
  },
};
</script>

<style scoped>
.table-innings .table,
.table-total,
.table thead th,
.modal-tables {
  background-color: #CFD7E0 !important;  
}

.modal-tables {
  border-radius: 5px;
}

table tbody+tbody,
.table th,
.table td {
  border: none;
}

.team-name span {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.table-teams thead tr th {
  height: 50px;
}

.table-teams tbody tr th {
  /* padding-top: 5px; */
}
</style>